import { ASSET_TAG_FILTER_PREFIX, AssetType } from '@kentik/ui-shared/labels/lib';
import { AssetCollectionModel } from 'app/stores/assetTags/$assetTags.types';
import $assetTags from 'app/stores/assetTags/$assetTags';

/**
 * Checks an asset collection model by field and asset type for a valid sort value
 */
export function getAssetTagSortValue({
  fieldName,
  assetType,
  relatedAssetModel
}: {
  fieldName: string | undefined;
  assetType: AssetType;
  relatedAssetModel: AssetCollectionModel;
}): string | number | undefined {
  if (fieldName?.startsWith(ASSET_TAG_FILTER_PREFIX)) {
    const assetTagModel = $assetTags.collection.get().find((model) => model.filterName === fieldName);
    if (assetTagModel) {
      return assetTagModel.getTagValue({ relatedAssetModel, assetType });
    }
  }

  return undefined;
}
